export const radians = Math.PI / 180;
export const degrees = 180 / Math.PI;



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-color/src/math.js
// module id = 268
// module chunks = 0